import { Lightning, Registry } from '@lightningjs/sdk'
import { transparent } from '../../constants/colors'
import { Images } from '../../constants/paths'
import { getAsset } from '../../utils/image'

export class SpriteAnimation extends Lightning.Component {
  private _intervalId: number
  private readonly _frames = 16
  private readonly _framesPerRow = 4
  private readonly _framesPerColumn = 4

  static _template() {
    return {
      w: (w) => w,
      h: (h) => h,
      rect: true,
      color: transparent,
      clipping: true,
      SpriteSheet: {
        src: getAsset(Images.LOGO_SPRITESHEET),
      },
    }
  }

  _active() {
    const xActions = Array(this._frames)
      .fill(null)
      .reduce((accumulator, _currentValue, index) => {
        accumulator = [...accumulator, this.w * (index % this._framesPerRow) * -1]
        return accumulator
      }, [])
    const yActions = Array(this._frames / this._framesPerColumn)
      .fill(null)
      .reduce((accumulator, _currentValue, index) => {
        accumulator = [...accumulator, this.h * index * -1]
        return accumulator
      }, [])

    let currentFrame = 0
    let yPosition = 0
    const totalDuration = 1.8 // in seconds
    const stepDuration = totalDuration / this._frames

    this._intervalId = Registry.setInterval(() => {
      currentFrame = currentFrame === this._frames - 1 ? 0 : currentFrame + 1

      if (currentFrame % this._framesPerRow === 0) {
        yPosition = yPosition === this._framesPerColumn - 1 ? 0 : yPosition + 1
      }

      this.spriteSheet.patch({
        x: xActions[currentFrame],
        y: yActions[yPosition],
      })
    }, stepDuration * 1000)
  }

  _inactive() {
    Registry.clearInterval(this._intervalId)
  }

  get spriteSheet() {
    return this.tag('SpriteSheet')
  }

  set width(v: number) {
    this.w = v
    this.spriteSheet.patch({
      w: v * this._framesPerRow,
    })
  }

  set height(v: number) {
    this.h = v
    this.spriteSheet.patch({
      h: v * this._framesPerColumn,
    })
  }
}
